// Used by Styled Components!
// @ts-ignore
// eslint-disable-next-line
window.__webpack_nonce__ = window.NONCE_ID;

// Fixes DraftJS 'global is not defined' error.
window.global = globalThis;
